export function mensagemErroFaq(erro, alternativa) {
  const status = erro && erro.response && erro.response.status;
  if (status === 400 || status === 422) return "Não foi possível concluir a operação. Verifique os dados informados.";
  if (status === 404) return "O registro não foi encontrado. Atualize a lista e tente novamente.";
  if (status === 409) return "Não foi possível concluir a operação por um conflito com os dados atuais. Atualize a lista e tente novamente.";
  return alternativa;
}
